import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import useStyles from 'substyle';
import { getModifiers } from './utils';
function StickInline({ node, children, component, containerRef, nestingKey, align, position, style, ...rest }) {
    const styles = useStyles(defaultStyle, { style }, getModifiers({ align, position }));
    const Component = component || 'div';
    return (_jsxs(Component, { ...rest, ...styles, ref: containerRef, "data-sticknestingkey": nestingKey, children: [children, node && _jsx("div", { ...styles('node'), children: node })] }));
}
const defaultStyle = {
    position: 'relative',
    node: {
        position: 'absolute',
        zIndex: 99,
        textAlign: 'left',
    },
    '&position-top': {
        node: {
            top: 0,
        },
    },
    '&position-middle': {
        node: {
            top: '50%',
        },
    },
    '&position-bottom': {
        node: {
            top: '100%',
        },
    },
    '&position-left': {
        node: {
            left: 0,
        },
    },
    '&position-center': {
        node: {
            left: '50%',
        },
    },
    '&position-right': {
        node: {
            left: '100%',
        },
    },
};
export default StickInline;
//# sourceMappingURL=StickInline.js.map